import Voetnoot from "../../components/Voetnoot"

const data = {
    title: '2.2. Procedure',
    content: <>
        <p>Voor het doorlopen van een m.e.r. geldt een wettelijk vastgestelde procedure. Bij een planMER is dit de uitgebreide procedure, waarbij onderstaande stappen moeten worden doorlopen.<Voetnoot id="14" /></p>


        <table>
            <tr className="kopje">
                <td>Uitgebreide m.e.r.-procedure Commissie m.e.r. </td>
                <td>Procedurele stappen provincie Zuid-Holland </td>
            </tr>

            <tr>
                <td>1. Melding van het project. Melding door initiatiefnemer aan bevoegd gezag voor aanvraag m.e.r.-plichtige vergunning</td>
                <td>Niet relevant voor deze procedure aangezien de provincie Zuid-Holland zowel initiatiefnemer als bevoegd gezag is.</td>
            </tr>
            <tr>
                <td>2. Kennisgeving. Het bevoegd gezag laat weten dat het een besluit aan het voorbereiden is.</td>
                <td rowspan="2">
                    <ul>
                        <li>Het voornemen om bij de partiële herziening van het provinciale omgevingsbeleid een m.e.r.-procedure te doorlopen is openbaar aangekondigd door de provincie Zuid-Holland op 7 november 2021, door het ter inzage leggen van de NRD (startdocument voor een m.e.r.-procedure).</li>
                        <li>De Ontwerp NRD heeft ter inzage gelegen van 8 november 2021 tot en met 20 december 2021. In deze periode kon iedere belanghebbende een zienswijze indienen op de NRD.</li>
                        <li>In dezelfde periode heeft de provincie de Commissie m.e.r. gevraagd een advies uit te brengen op de NRD.</li>
                        <li>De Commissie m.e.r. bracht hier op 20 december 2021 advies over uit.<Voetnoot id="15" /></li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>3. Raadpleging. Het bevoegd gezag raadpleegt de overheidsorganen en de adviseurs die bij het besluit moeten worden betrokken over de reikwijdte en het detailniveau van het m.e.r.</td>
            </tr>
            <tr>
                <td>4. Advies over reikwijdte en detailniveau m.e.r. Bevoegd gezag stelt advies over reikwijdte en detailniveau van het op te stellen MER vast.</td>
                <td>De reikwijdte en het detailniveau van de uit te voeren m.e.r. zijn door Gedeputeerde Staten van Zuid-Holland (hierna: GS) vastgesteld op 25 januari 2022.<Voetnoot id="16" /> Ook is daarbij de Nota van Beantwoording vastgesteld.<Voetnoot id="17" /></td>
            </tr>
            <tr>
                <td>5. Milieueffectrapport. Initiatiefnemer (of bevoegd gezag) stelt een MER op.</td>
                <td>Het MER is opgesteld overeenkomstig de vastgestelde reikwijdte en detailniveau, en de inhoudsvereisten zoals voorgeschreven in de Wet milieubeheer.</td>
            </tr>
            <tr>
                <td>6. Kennisgeving en terinzagelegging. Het bevoegd gezag geeft kennis van het milieueffectrapport en de aanvraag/het (voor-) ontwerpbesluit en legt beide ter inzage.</td>
                <td rowspan="2">Het MER is onderdeel van de Herziening Energietransitie, en ligt daarmee samen met de herziening ter inzage van 6 juni tot en met 1 augustus 2022. In deze periode kan iedere belanghebbende een zienswijze indienen op de herziening en/of het MER.</td>
            </tr>
            <tr>
                <td>7. Inspraak. Mogelijkheid tot het indienen van zienswijzen over het MER en de aanvraag/ het (voor)ontwerpbesluit.</td>
            </tr>
            <tr>
                <td>8. Advisering Commissie m.e.r. Commissie m.e.r. brengt advies uit over MER.</td>
                <td>Gelijktijdig met de terinzagelegging zal de Commissie m.e.r. het MER toetsen en een advies over het MER uitbrengen.</td>
            </tr>
            <tr>
                <td>9. Definitief besluit. Bevoegd gezag neemt een besluit, waarbij rekening wordt gehouden met de beschreven milieugevolgen, alternatieven, zienswijzen en het advies van de Commissie m.e.r. Daarnaast worden de mogelijkheden tot participatie beschreven alsmede er vastgesteld wordt hoe en wanneer er geëvalueerd wordt. </td>
                <td>De provincie Zuid-Holland geeft in de Herziening aan hoe met de resultaten van het MER, de inspraak en eventueel de zienswijzen en het advies van de Commissie m.e.r. is omgegaan.</td>
            </tr>
            <tr>
                <td>10. Bekendmaking besluit.</td>
                <td>De provincie Zuid-Holland zal via haar kanalen het besluit kenbaar maken aan de buitenwereld. </td>
            </tr>
            <tr>
                <td>11. Evaluatie. Bevoegd gezag evalueert de werkelijk optredende milieugevolgen zoals beschreven in evaluatieparagraaf besluit. Waar nodig neemt bevoegd gezag maatregelen om de gevolgen voor het milieu te beperken. </td>
                <td>Evaluatie (na realisatie) van de daadwerkelijk optredende milieugevolgen van de uitvoering van het plan te monitoren en te evalueren</td>                
            </tr>
        </table>

    </>,
    sources_used: [14, 15, 16, 17],
    prev: '/energietransitie/2/1',
    next: '/energietransitie/2/3',

}

export default data